import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Download, Lock, Clock } from 'lucide-react';
import { BookMockup } from './BookMockup';
export function Hero() {
  return <section className="relative pt-12 pb-12 overflow-hidden" data-id="element-97">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-98">
        <div className="absolute inset-0 bg-background/90 z-10" data-id="element-99"></div>
        <img src="https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=1200&auto=format&fit=crop" alt="Luxury Yacht" className="w-full h-full object-cover opacity-20" data-id="element-100" />
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-primary/20 rounded-full blur-[100px] z-10" data-id="element-101"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-primary/10 rounded-full blur-[80px] z-10" data-id="element-102"></div>
      </div>

      <div className="relative z-20 px-5" data-id="element-103">
        <div className="flex flex-col items-center gap-8 text-center" data-id="element-104">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-medium" data-id="element-105">
            <span className="relative flex h-2 w-2" data-id="element-106">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" data-id="element-107"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" data-id="element-108"></span>
            </span>
            Oportunidad Internacional
          </motion.div>

          {/* Book Mockup at the top - vertical mobile hero */}
          <motion.div className="w-full flex justify-center -my-2" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} data-id="element-109">
            <BookMockup data-id="element-110" />
          </motion.div>

          {/* Title + Subtitle */}
          <motion.div className="space-y-5" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-111">
            <h1 className="text-3xl sm:text-4xl font-bold text-white leading-tight font-heading tracking-tight" data-id="element-112">
              Generá más de{' '}
              <span className="text-primary" data-id="element-113">USD 3.000 por mes</span> trabajando
              de chef en yates internacionales
            </h1>

            <p className="text-base text-white/75 leading-relaxed px-2" data-id="element-114">
              La guía paso a paso para transformar tu experiencia gastronómica
              en una carrera internacional y comenzar a trabajar en yates sin
              empezar desde cero.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div className="w-full space-y-5 pt-2" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-115">
            <Button size="lg" asChild className="w-full text-base px-6 py-6 bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_40px_-10px_rgba(212,168,87,0.6)] transition-all active:scale-95 rounded-2xl font-bold" data-id="element-116">
              <a href="https://checkout.librofy.online/cart/53242880491883:1" target="_blank" rel="noopener noreferrer" data-id="element-117">
                👉 QUIERO ACCESO INMEDIATO
              </a>
            </Button>

            <div className="grid grid-cols-2 gap-2 text-xs text-white/70" data-id="element-118">
              <div className="flex items-center gap-1.5 justify-center" data-id="element-119">
                <Download className="w-3.5 h-3.5 text-primary shrink-0" data-id="element-120" />
                <span data-id="element-121">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-1.5 justify-center" data-id="element-122">
                <Clock className="w-3.5 h-3.5 text-primary shrink-0" data-id="element-123" />
                <span data-id="element-124">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-1.5 justify-center" data-id="element-125">
                <Lock className="w-3.5 h-3.5 text-primary shrink-0" data-id="element-126" />
                <span data-id="element-127">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5 justify-center" data-id="element-128">
                <Shield className="w-3.5 h-3.5 text-primary shrink-0" data-id="element-129" />
                <span data-id="element-130">Garantía 7 días</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}